import { useState, useEffect } from 'react';
import styles from './RoboKidsPage.module.css';

export default function RoboKidsPage4() {
  const [guardianName, setGuardianName] = useState('');
  const [email, setEmail] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [childName, setChildName] = useState('');
  const [childAge, setChildAge] = useState('');
  const [startDate, setStartDate] = useState('');
  const [slideshowIndex, setSlideshowIndex] = useState(0);
  const [secondSlideshowIndex, setSecondSlideshowIndex] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const availableDates = ['2026-02-10', '2026-02-11', '2026-02-12', '2026-02-13'];

  const placeholderImages = [
    '/images/robokids-custom/custom1.png',
    '/images/robokids-custom/custom2.png',
    '/images/robokids-custom/custom3.png',
  ];

  const secondSlideshowImages = [
    '/images/robokids-custom/custom4.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideshowIndex((prev) => (prev + 1) % placeholderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondSlideshowIndex((prev) => (prev + 1) % secondSlideshowImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

const handleRegister = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  const formData = {
    guardianName,
    childName,
    childAge,
    email,
    addressLine1: address1,
    addressLine2: address2,
    city,
    state,
    zipCode: zip,
    startDate,
    classType: 'custom',
  };

  try {
    const response = await fetch("https://vgiqj6ha4n5pewmu4zkwhsac740nucsz.lambda-url.us-east-1.on.aws/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (response.ok && data.checkoutUrl) {
      // ✅ Save the formData for later use (waiver, success, etc.)
      sessionStorage.setItem("roboKidsWaiverSession", JSON.stringify(formData));

      // ✅ Redirect to Stripe checkout (do NOT append query params)
      window.location.href = data.checkoutUrl;
    } else {
      alert(data.message || "Registration failed. Please try again.");
    }
  } catch (error) {
    console.error("Error submitting registration:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setSubmitting(false);
  }
};



  return (
    <div className={styles.roboKidsWrapper}>
      {/* Left column: registration form */}
      <div className={styles.leftColumn}>
        <h2>Register for Robo Kids Custom Class!</h2>
        <form className={styles.form} onSubmit={handleRegister}>
          <label>Guardian Name:</label>
          <input type="text" required value={guardianName} onChange={(e) => setGuardianName(e.target.value)} />
          <label>Email:</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <label>Address Line 1:</label>
          <input type="text" required value={address1} onChange={(e) => setAddress1(e.target.value)} />
          <label>Address Line 2 (optional):</label>
          <input type="text" value={address2} onChange={(e) => setAddress2(e.target.value)} />
          <label>City:</label>
          <input type="text" required value={city} onChange={(e) => setCity(e.target.value)} />
          <label>State:</label>
          <input type="text" required value={state} onChange={(e) => setState(e.target.value)} />
          <label>ZIP Code:</label>
          <input type="text" required pattern="\d{5}" value={zip} onChange={(e) => setZip(e.target.value)} />
          <label>Child’s First Name:</label>
          <input type="text" required value={childName} onChange={(e) => setChildName(e.target.value)} />
          <label>Child’s Age:</label>
          <input type="number" required min="5" value={childAge} onChange={(e) => setChildAge(e.target.value)} />
          <label>Choose Class Start Date:</label>
          <select required value={startDate} onChange={(e) => setStartDate(e.target.value)}>
            <option value="">Select a date</option>
            {availableDates.map(date => (
              <option key={date} value={date}>
                {new Date(date + "T00:00:00").toLocaleDateString(undefined, {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </option>
            ))}
          </select>

          <button type="submit" disabled={submitting} className={styles.registerButton}>
            {submitting ? "Processing..." : "Proceed to Payment"}
          </button>
        </form>
      </div>

      {/* Middle column: slideshows */}
      <div className={styles.slideshowColumn}>
        <div className={styles.slideshowContainer}>
          <img
            src={placeholderImages[slideshowIndex]}
            alt={`Slideshow image ${slideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p>Enroll your child today!</p>
        </div>
        <div className={styles.slideshowContainer}>
          <img
            src={secondSlideshowImages[secondSlideshowIndex]}
            alt={`Second slideshow image ${secondSlideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p style={{ fontSize: '0.75rem', color: '#777' }}>
            Actual kit contents may vary in types, essential components will be the same.
          </p>
        </div>
      </div>

    {/* Right column: About + FAQ */}
<div className={styles.rightColumn}>
  <h2>Custom AI Robotics Innovation Lab – $1000</h2>
  <p>
    This lab is for future inventors who want to design <strong>their own AI robots</strong>.
    With one-on-one instructor support, kids choose projects like voice-reactive robots,
    vision-based bots, or original designs — turning ideas into reality.
  </p>
  <ul>
    <li><strong>What's Included:</strong>
      <ul>
        <li>Full robotics toolkit with expanded sensors and controllers</li>
        <li>Optional add-ons: microphone, camera, or wireless modules</li>
        <li>Flexible building chassis with universal connectors</li>
        <li>Instructor-guided coding environment with AI modules</li>
      </ul>
    </li>
    <li><strong>6–8 Week Program:</strong> Personalized live video call sessions with direct instructor mentoring.</li>
    <li><strong>What Kids Will Learn:</strong>
      <ul>
        <li>How to plan and design a unique AI robotics project</li>
        <li>Advanced coding tailored to their chosen build</li>
        <li>Problem-solving like real engineers</li>
        <li>Presentation of their final innovation project</li>
      </ul>
    </li>
    <li><strong>Recommended Age:</strong> 11–16 years. Best for students eager to innovate beyond structured classes.</li>
  </ul>

  <div className={styles.faqBox}>
    <h3>❓ Frequently Asked Questions</h3>
    <details><summary><strong>What makes this different?</strong></summary><p>Unlike other levels, students design their own project with dedicated instructor time.</p></details>
    <details><summary><strong>Can kids choose any idea?</strong></summary><p>Yes — from voice-activated robots to AI-driven vehicles. We help scope projects to fit skill level.</p></details>
    <details><summary><strong>How much instructor support is included?</strong></summary><p>1-on-1 guidance is built into every session so projects stay on track.</p></details>
    <details><summary><strong>Will kids learn coding?</strong></summary><p>Yes. Coding is central, with direct application to their chosen project.</p></details>
    <details><summary><strong>Can siblings share?</strong></summary><p>Yes, though each child may want their own kit if pursuing different projects.</p></details>
  </div>
</div>


    </div>
  );
}
